/* Lupin Gold: "Thanks, your vote's in" bar for the RISE pack vote email (Goldie 13/10/2026).
   Shows only when the URL has pack_vote=A|B|C|D|E, once per browser session. No tracking. */
(function () {
  try {
    var v = (new URLSearchParams(window.location.search).get('pack_vote') || '').toUpperCase();
    if (!/^[A-E]$/.test(v)) return;
    if (window.sessionStorage && sessionStorage.getItem('lgPackVoteThanks')) return;
    function show() {
      if (document.getElementById('lg-pack-vote-thanks')) return;
      var bar = document.createElement('div');
      bar.id = 'lg-pack-vote-thanks';
      bar.setAttribute('role', 'status');
      bar.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:2147483000;' +
        'width:calc(100% - 32px);max-width:520px;box-sizing:border-box;background:#090807;color:#F4EBD8;' +
        'border:2px solid #F9CE0A;border-radius:12px;padding:14px 48px 14px 18px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.35);font-family:inherit;line-height:1.35;text-align:left';
      bar.innerHTML = '<div style="font-weight:800;font-size:18px;color:#F9CE0A;margin:0">Thanks, your vote’s in.</div>' +
        '<div style="font-size:14px;margin-top:4px;opacity:.9">We’ll share which pack wins.</div>' +
        '<button type="button" aria-label="Close" style="position:absolute;top:8px;right:10px;background:none;border:0;' +
        'color:#F4EBD8;font-size:24px;line-height:1;cursor:pointer;padding:4px 6px">&times;</button>';
      bar.querySelector('button').onclick = function () { bar.remove(); };
      document.body.appendChild(bar);
      try { sessionStorage.setItem('lgPackVoteThanks', '1'); } catch (e) {}
    }
    if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);
  } catch (e) {}
})();
